define(function (require) {
	const Radio = require('backbone.radio');
	const tpl = require('./templates/t_itv_saved_searches.hbs');
	const modal_region = require('civicsUtils/modal_region');
	const confirmDeleteModal = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');
	const ViewManager = require('civicsUtils/view_manager');
	const dashboardChannel = Radio.channel('dashboardChannel');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			modalRegion: {
				regionClass: modal_region,
				selector: 'body .rhythm-modals'
			},
			confirmationRegion: {
				selector: '.confirmation-modal-container', // Add a sub-region
			}
		},
		tagName: 'div',
		className: 'manage-saved-search-items',
		ui: {
			editSaveSearch: '.edit-save-search',
			deleteSaveSearch: '.delete-save-search',
			setDefaultSaveSearch: '.set-default-save-search',
			confirmEdit: '.confirm-edit',
			cancelEdit: '.cancel-edit',
			manageSavedSearchesActionBtn: '.manage-saved-searches-action-btn',
			manageConfirmCancelBtn: '.manage-confirm-cancel-edit-btn',
			searchNameInput: '#EditSaveSearch',
			searchName: '.search-name',
			confirmationModalContaienr: '.confirmation-modal-container'
		},
		events: {
			'click @ui.editSaveSearch': 'editSearch',
			'click @ui.deleteSaveSearch': 'onDeleteClick',
			'click @ui.setDefaultSaveSearch': 'setDefaultSaveSearch',
			'click @ui.cancelEdit': 'closeEdit',
			'click @ui.confirmEdit': 'confirmSave'
		},
		initialize: function (options) {
			this.collection = options.collection; // Assign collection if passed explicitly
    		this.config = options.config; // Assign config if passed explicitly

			this.listenTo(this.model, 'change', this.render); // Automatically re-render on model change
			this.listenTo(this.model, 'change:disabled', this.render); // Automatically re-render on changes
			this.listenTo(this.model, 'change:isEditing', this.render);
		},
		onShow:function(){

		},
		confirmSave: function () {
			const updatedName = this.$el.find('.saved-search input').val().trim();
            if (updatedName) {
				this.model.set('name', updatedName); // Update the model
                this.triggerMethod('edit:search', updatedName);
				this.triggerMethod('reset:editButtons'); // Re-enable all edit buttons after save
            } else {
				ViewManager.errorToWindow({
					validationError: {
					  "emptySearchNameOnEdit": i18n.t('CIVICS.COMMON.SAVE_SEARCH_EMPTY_SEARCH_NAME')
					}
				}, this);
				return;
			}
		},
		editSearch: function () {
			this.model.set({
				isEditing: true,
				disabled: false
			});

			this.triggerMethod('child:editing', this.model);
			var oldval = this.ui.searchNameInput.val();
			this.ui.searchNameInput.focus().val(oldval);
			this.ui.searchNameInput[0].setSelectionRange(oldval.length, oldval.length);

			
		},
		closeEdit: function () {
			this.model.set({
				isEditing: false, // Exit editing mode
				disabled: false   // Re-enable the button
			});
			this.triggerMethod('reset:editButtons');
		},
		onDeleteClick: function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();

			// Remove hidden class of this container so we can show the confirmation modal in this.showChildView()
			this.ui.confirmationModalContaienr.removeClass('hidden');

			let confirmDeleteSavedSearch = new confirmDeleteModal({
				title: i18n.t('CIVICS.COMMON.SAVE_SEARCH_DELETE_SEARCH'),
				instructions: i18n.t('CIVICS.COMMON.SAVE_SEARCH_DELETE_SEARCH_CONFIRMATION'),
				cancelButtonText: i18n.t('CIVICS.COMMON.NO'),
				submitButtonText: i18n.t('CIVICS.COMMON.YES'),
				confirmationCallback: this.onConfirmDelete.bind(this),
			});

			// Show confirmation modal as child view of parent modal
			this.showChildView('confirmationRegion', confirmDeleteSavedSearch);
			return false;
		},
		onConfirmDelete: function () {
			ViewManager.loading(true);

			this.model.destroy({
				success: (model, response) => {
					// Handle successful deletion
					dashboardChannel.trigger('saveSearches:update');
					dashboardChannel.trigger('delete:item');
					ViewManager.loading(false);
				},
				error: (model, response) => {
					// Handle errors
					ViewManager.errorToWindow(response, this);
					ViewManager.loading(false);
				}
			});
		},
		setDefaultSaveSearch: function () {
			ViewManager.loading(true);

			const isCurrentlyDefault = this.model.get('isDefault');
			const currentSource = this.model.get('source');

			// Toggle the default status
			this.model.set('isDefault', !isCurrentlyDefault);
			this.model.unset('lastModifiedDateTime', { silent: true }); // avoid date conversion issues
			this.model.unset('searchData', { silent: true });

			// Save the current model
			this.model.save(null, {
				success: (model, response) => {
				// Unset default on other items but only if they belong to the same source
				this.collection.each((item) => {
					if (item !== this.model && item.get('isDefault') && item.get('source') === currentSource) {
					item.set('isDefault', false);
					}
				});
					dashboardChannel.trigger('saveSearches:update');
					ViewManager.loading(false);
				},
				error: (model, response) => {
				ViewManager.errorToWindow(response, this);
				ViewManager.loading(false);
				}
			});
		},
		templateHelpers: function() {
			return {
				isEditing: this.model.get('isEditing'),
				searchName: this.model.get('name'),
				disabled: this.model.get('disabled'),
				isDefault: this.model.get('isDefault')
			}
		},
	});
});
